export const translations = {
    sources: {
        website: {
            "00": "Website"
        },
        newsgroup: {
            "00": "Newsgroup/Newsfeed"
        },
        socialnetwork: {
            en: "Social Media Network",
            de: "Soziales Netzwerk",
            fr: "Réseau de médias sociaux"
        },
        tor: {
            "00": "TOR/Onion"
        },
        app: {
            "00": "App (Telegram)"
        },
        filehoster: {
            "00": "Filehoster (Mega, etc.)"
        },
        streaming: {
            "00": "Streaming"
        },
        ftp: {
            "00": "FTP"
        },
        other: {
            de: "Anderes",
            en: "Other",
            fr: "Autre"
        }
    }
};
